import { keys, map } from "lodash-es";
import { copy } from "shared/assets";
import { FIELD_SIZES } from "shared/constants";
import { IFieldType, IFormFields } from "shared/types";
import { IStageCapacityType } from "Venues/types";
import { capacityTypeOptions } from "Venues/utils";

const { properties } = copy.stageProperties.capacities;

export const fields: IFormFields = [
  {
    type: IFieldType.text,
    name: "capacity.title",
    label: properties.title.title,
    validation: {
      required: true,
    },
    style: {
      gridColumn: "span 4",
      mobile: {
        gridColumn: "span 5",
      },
    },
  },
  {
    type: IFieldType.number,
    name: "capacity.capacity",
    label: properties.capacity.title,
    validation: {
      required: true,
      min: 0,
      max: FIELD_SIZES.NUMBER,
      validate: (value: number) => Number.isInteger(value),
    },
    placeholder: properties.capacity.placeholder,
    allowNegative: false,
    decimalScale: 0,
    style: {
      gridColumn: "span 2",
    },
  },
  {
    type: IFieldType.select,
    name: "capacity.type",
    label: properties.capacityType.title,
    validation: {
      required: true,
      validate: (value: string) => keys(IStageCapacityType).includes(value),
    },
    placeholder: properties.capacityType.placeholder,
    options: map(IStageCapacityType, value => ({
      label: capacityTypeOptions[value],
      value,
    })),
    style: {
      gridColumn: "span 3",
    },
  },
];

export const defaultValues = {
  capacity: { title: null, capacity: "", type: null },
};

export const style = {
  gridTemplateColumns: "repeat(9, 1fr)",
  mobile: { gridTemplateColumns: "repeat(5, 1fr)" },
};
